export const scenes = [
  {
    title: 'Scene #1',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/9.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-1/10.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-1/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #2',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-2/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-2/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #3',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-3/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-3/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #4',
    frames: [
      // 'https://lidar-now.scale.ai/example_data/pandaset/scene-4/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/9.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-4/10.json'
      // 'https://lidar-now.scale.ai/example_data/pandaset/scene-4/11.json',
      // 'https://lidar-now.scale.ai/example_data/pandaset/scene-4/12.json',
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-4/annotations.json',
    showImages: true,
    frame: 0
  },
  {
    title: 'Scene #5',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-5/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-5/annotations.json',
    showImages: true,
    frame: 0,
    showProjectedPoints: true,
    segmentationScene: true,
    labelMapping: [
      {
        label: 'Smoke',
        index: 1
      },
      {
        label: 'Exhaust',
        index: 2
      },
      {
        label: 'Spray or rain',
        index: 3
      },
      {
        label: 'Reflection',
        index: 4
      },
      {
        label: 'Vegetation',
        index: 5
      },
      {
        label: 'Ground',
        index: 6
      },
      {
        label: 'Road',
        index: 7
      },
      {
        label: 'Lane Line Marking',
        index: 8
      },
      {
        label: 'Stop Line Marking',
        index: 9
      },
      {
        label: 'Other Road Marking',
        index: 10
      },
      {
        label: 'Sidewalk',
        index: 11
      },
      {
        label: 'Driveway',
        index: 12
      },
      {
        label: 'Car',
        index: 13
      },
      {
        label: 'Pickup Truck',
        index: 14
      },
      {
        label: 'Medium-sized Truck',
        index: 15
      },
      {
        label: 'Semi-truck',
        index: 16
      },
      {
        label: 'Towed Object',
        index: 17
      },
      {
        label: 'Motorcycle',
        index: 18
      },
      {
        label: 'Other Vehicle - Construction Vehicle',
        index: 19
      },
      {
        label: 'Other Vehicle - Uncommon',
        index: 20
      },
      {
        label: 'Other Vehicle - Pedicab',
        index: 21
      },
      {
        label: 'Emergency Vehicle',
        index: 22
      },
      {
        label: 'Bus',
        index: 23
      },
      {
        label: 'Personal Mobility Device',
        index: 24
      },
      {
        label: 'Motorized Scooter',
        index: 25
      },
      {
        label: 'Bicycle',
        index: 26
      },
      {
        label: 'Train',
        index: 27
      },
      {
        label: 'Trolley',
        index: 28
      },
      {
        label: 'Tram / Subway',
        index: 29
      },
      {
        label: 'Pedestrian',
        index: 30
      },
      {
        label: 'Pedestrian with Object',
        index: 31
      },
      {
        label: 'Animals - Bird',
        index: 32
      },
      {
        label: 'Animals - Other',
        index: 33
      },
      {
        label: 'Pylons',
        index: 34
      },
      {
        label: 'Road Barriers',
        index: 35
      },
      {
        label: 'Signs',
        index: 36
      },
      {
        label: 'Cones',
        index: 37
      },
      {
        label: 'Construction Signs',
        index: 38
      },
      {
        label: 'Temporary Construction Barriers',
        index: 39
      },
      {
        label: 'Rolling Containers',
        index: 40
      },
      {
        label: 'Building',
        index: 41
      },
      {
        label: 'Other Static Object',
        index: 42
      }
    ]
  },
  {
    title: 'Scene #6',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-6/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-6/annotations.json',
    showImages: true,
    frame: 0,
    showProjectedPoints: true,
    segmentationScene: true,
    labelMapping: [
      {
        label: 'Smoke',
        index: 1
      },
      {
        label: 'Exhaust',
        index: 2
      },
      {
        label: 'Spray or rain',
        index: 3
      },
      {
        label: 'Reflection',
        index: 4
      },
      {
        label: 'Vegetation',
        index: 5
      },
      {
        label: 'Ground',
        index: 6
      },
      {
        label: 'Road',
        index: 7
      },
      {
        label: 'Lane Line Marking',
        index: 8
      },
      {
        label: 'Stop Line Marking',
        index: 9
      },
      {
        label: 'Other Road Marking',
        index: 10
      },
      {
        label: 'Sidewalk',
        index: 11
      },
      {
        label: 'Driveway',
        index: 12
      },
      {
        label: 'Car',
        index: 13
      },
      {
        label: 'Pickup Truck',
        index: 14
      },
      {
        label: 'Medium-sized Truck',
        index: 15
      },
      {
        label: 'Semi-truck',
        index: 16
      },
      {
        label: 'Towed Object',
        index: 17
      },
      {
        label: 'Motorcycle',
        index: 18
      },
      {
        label: 'Other Vehicle - Construction Vehicle',
        index: 19
      },
      {
        label: 'Other Vehicle - Uncommon',
        index: 20
      },
      {
        label: 'Other Vehicle - Pedicab',
        index: 21
      },
      {
        label: 'Emergency Vehicle',
        index: 22
      },
      {
        label: 'Bus',
        index: 23
      },
      {
        label: 'Personal Mobility Device',
        index: 24
      },
      {
        label: 'Motorized Scooter',
        index: 25
      },
      {
        label: 'Bicycle',
        index: 26
      },
      {
        label: 'Train',
        index: 27
      },
      {
        label: 'Trolley',
        index: 28
      },
      {
        label: 'Tram / Subway',
        index: 29
      },
      {
        label: 'Pedestrian',
        index: 30
      },
      {
        label: 'Pedestrian with Object',
        index: 31
      },
      {
        label: 'Animals - Bird',
        index: 32
      },
      {
        label: 'Animals - Other',
        index: 33
      },
      {
        label: 'Pylons',
        index: 34
      },
      {
        label: 'Road Barriers',
        index: 35
      },
      {
        label: 'Signs',
        index: 36
      },
      {
        label: 'Cones',
        index: 37
      },
      {
        label: 'Construction Signs',
        index: 38
      },
      {
        label: 'Temporary Construction Barriers',
        index: 39
      },
      {
        label: 'Rolling Containers',
        index: 40
      },
      {
        label: 'Building',
        index: 41
      },
      {
        label: 'Other Static Object',
        index: 42
      }
    ]
  },
  {
    title: 'Scene #7',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-7/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-7/annotations.json',
    showImages: true,
    frame: 0,
    showProjectedPoints: true,
    segmentationScene: true,
    labelMapping: [
      {
        label: 'Smoke',
        index: 1
      },
      {
        label: 'Exhaust',
        index: 2
      },
      {
        label: 'Spray or rain',
        index: 3
      },
      {
        label: 'Reflection',
        index: 4
      },
      {
        label: 'Vegetation',
        index: 5
      },
      {
        label: 'Ground',
        index: 6
      },
      {
        label: 'Road',
        index: 7
      },
      {
        label: 'Lane Line Marking',
        index: 8
      },
      {
        label: 'Stop Line Marking',
        index: 9
      },
      {
        label: 'Other Road Marking',
        index: 10
      },
      {
        label: 'Sidewalk',
        index: 11
      },
      {
        label: 'Driveway',
        index: 12
      },
      {
        label: 'Car',
        index: 13
      },
      {
        label: 'Pickup Truck',
        index: 14
      },
      {
        label: 'Medium-sized Truck',
        index: 15
      },
      {
        label: 'Semi-truck',
        index: 16
      },
      {
        label: 'Towed Object',
        index: 17
      },
      {
        label: 'Motorcycle',
        index: 18
      },
      {
        label: 'Other Vehicle - Construction Vehicle',
        index: 19
      },
      {
        label: 'Other Vehicle - Uncommon',
        index: 20
      },
      {
        label: 'Other Vehicle - Pedicab',
        index: 21
      },
      {
        label: 'Emergency Vehicle',
        index: 22
      },
      {
        label: 'Bus',
        index: 23
      },
      {
        label: 'Personal Mobility Device',
        index: 24
      },
      {
        label: 'Motorized Scooter',
        index: 25
      },
      {
        label: 'Bicycle',
        index: 26
      },
      {
        label: 'Train',
        index: 27
      },
      {
        label: 'Trolley',
        index: 28
      },
      {
        label: 'Tram / Subway',
        index: 29
      },
      {
        label: 'Pedestrian',
        index: 30
      },
      {
        label: 'Pedestrian with Object',
        index: 31
      },
      {
        label: 'Animals - Bird',
        index: 32
      },
      {
        label: 'Animals - Other',
        index: 33
      },
      {
        label: 'Pylons',
        index: 34
      },
      {
        label: 'Road Barriers',
        index: 35
      },
      {
        label: 'Signs',
        index: 36
      },
      {
        label: 'Cones',
        index: 37
      },
      {
        label: 'Construction Signs',
        index: 38
      },
      {
        label: 'Temporary Construction Barriers',
        index: 39
      },
      {
        label: 'Rolling Containers',
        index: 40
      },
      {
        label: 'Building',
        index: 41
      },
      {
        label: 'Other Static Object',
        index: 42
      }
    ]
  },
  {
    title: 'Scene #8',
    frames: [
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/0.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/1.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/2.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/3.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/4.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/5.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/6.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/7.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/8.json',
      'https://lidar-now.scale.ai/example_data/pandaset/scene-8/9.json'
    ],
    annotations: 'https://lidar-now.scale.ai/example_data/pandaset/scene-8/annotations.json',
    showImages: true,
    frame: 0,
    showProjectedPoints: true,
    segmentationScene: true,
    labelMapping: [
      {
        label: 'Smoke',
        index: 1
      },
      {
        label: 'Exhaust',
        index: 2
      },
      {
        label: 'Spray or rain',
        index: 3
      },
      {
        label: 'Reflection',
        index: 4
      },
      {
        label: 'Vegetation',
        index: 5
      },
      {
        label: 'Ground',
        index: 6
      },
      {
        label: 'Road',
        index: 7
      },
      {
        label: 'Lane Line Marking',
        index: 8
      },
      {
        label: 'Stop Line Marking',
        index: 9
      },
      {
        label: 'Other Road Marking',
        index: 10
      },
      {
        label: 'Sidewalk',
        index: 11
      },
      {
        label: 'Driveway',
        index: 12
      },
      {
        label: 'Car',
        index: 13
      },
      {
        label: 'Pickup Truck',
        index: 14
      },
      {
        label: 'Medium-sized Truck',
        index: 15
      },
      {
        label: 'Semi-truck',
        index: 16
      },
      {
        label: 'Towed Object',
        index: 17
      },
      {
        label: 'Motorcycle',
        index: 18
      },
      {
        label: 'Other Vehicle - Construction Vehicle',
        index: 19
      },
      {
        label: 'Other Vehicle - Uncommon',
        index: 20
      },
      {
        label: 'Other Vehicle - Pedicab',
        index: 21
      },
      {
        label: 'Emergency Vehicle',
        index: 22
      },
      {
        label: 'Bus',
        index: 23
      },
      {
        label: 'Personal Mobility Device',
        index: 24
      },
      {
        label: 'Motorized Scooter',
        index: 25
      },
      {
        label: 'Bicycle',
        index: 26
      },
      {
        label: 'Train',
        index: 27
      },
      {
        label: 'Trolley',
        index: 28
      },
      {
        label: 'Tram / Subway',
        index: 29
      },
      {
        label: 'Pedestrian',
        index: 30
      },
      {
        label: 'Pedestrian with Object',
        index: 31
      },
      {
        label: 'Animals - Bird',
        index: 32
      },
      {
        label: 'Animals - Other',
        index: 33
      },
      {
        label: 'Pylons',
        index: 34
      },
      {
        label: 'Road Barriers',
        index: 35
      },
      {
        label: 'Signs',
        index: 36
      },
      {
        label: 'Cones',
        index: 37
      },
      {
        label: 'Construction Signs',
        index: 38
      },
      {
        label: 'Temporary Construction Barriers',
        index: 39
      },
      {
        label: 'Rolling Containers',
        index: 40
      },
      {
        label: 'Building',
        index: 41
      },
      {
        label: 'Other Static Object',
        index: 42
      }
    ]
  }
];

export default scenes;
